export default "__VITE_ASSET__DuxFgudN__"